export default "__VITE_ASSET__Whs2Jytd__"